import { observer } from "mobx-react-lite";
import IconTuner from "@asphalt-react/icontuner";
import { Info } from "@asphalt-react/iconpack";
import { FilePickerContent } from "./Content.component";
import * as React from "react";
import styled, { css } from "styled-components";
import { useFilePickerState } from "../states";
import { FilePickerInput } from "./Input.component";

const WrapperEl = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 258px;
  justify-content: center;
  position: relative;
  width: 100%;
  ${(props) =>
    props &&
    css`
      background: ${props.theme.colors.background.filePicker};
      border-radius: ${props.theme.dimension.spacing.xs}px;
      border: 1px dashed ${props.theme.colors.borders.filePicker};
    `}
`;

const InfoIconEl = styled.div`
  position: absolute;
  cursor: pointer;
  ${(props) =>
    css`
      z-index: ${props.theme.layout.zIndex.filePickerTooltip};
      left: ${props.theme.layout.margin.l}px;
      top: ${props.theme.layout.margin.l}px;
    `}
`;

export const FilePickerContainer: React.FC = observer(() => {
  const { onInfoClick } = useFilePickerState();

  return (
    <WrapperEl>
      <>
        {onInfoClick && (
          <InfoIconEl onClick={onInfoClick}>
            <IconTuner info>
              <Info />
            </IconTuner>
          </InfoIconEl>
        )}
        <FilePickerInput />
        <FilePickerContent />
      </>
    </WrapperEl>
  );
});
